export default "__VITE_ASSET__1XrSmXWi__"